import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeLogin } from '../auth/oauth';
import { useAuth } from '../auth/AuthContext';

export function CallbackPage() {
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // guard StrictMode double-invoke (code is single-use)
    ran.current = true;
    void (async () => {
      try {
        const tokens = await completeLogin(new URLSearchParams(window.location.search));
        setSession(tokens);
        navigate('/', { replace: true });
      } catch (e: unknown) {
        setError(e instanceof Error ? e.message : String(e));
      }
    })();
  }, [navigate, setSession]);

  return (
    <div className="p-8">
      {error ? (
        <p className="text-red-600">Sign-in failed: {error}</p>
      ) : (
        <p className="text-neutral-500">Completing sign-in…</p>
      )}
    </div>
  );
}
